/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionRecommendCodeVo } from './CommissionRecommendCodeVo';
import {
    CommissionRecommendCodeVoFromJSON,
    CommissionRecommendCodeVoFromJSONTyped,
    CommissionRecommendCodeVoToJSON,
    CommissionRecommendCodeVoToJSONTyped,
} from './CommissionRecommendCodeVo';

/**
 * 
 * @export
 * @interface CommissionPartnerPageItemVo
 */
export interface CommissionPartnerPageItemVo {
    /**
     * 会员id
     * @type {number}
     * @memberof CommissionPartnerPageItemVo
     */
    userId?: number;
    /**
     * 会员编号
     * @type {string}
     * @memberof CommissionPartnerPageItemVo
     */
    userCode?: string;
    /**
     * 会员名
     * @type {string}
     * @memberof CommissionPartnerPageItemVo
     */
    userName?: string;
    /**
     * 用户名（登录账号）
     * @type {string}
     * @memberof CommissionPartnerPageItemVo
     */
    account?: string;
    /**
     * 推荐人号码（该会员的推荐码列表，含id）
     * @type {Array<CommissionRecommendCodeVo>}
     * @memberof CommissionPartnerPageItemVo
     */
    recommendCodes?: Array<CommissionRecommendCodeVo>;
    /**
     * 邀新注册人数（所选年份内通过该会员推荐码注册的会员数）
     * @type {number}
     * @memberof CommissionPartnerPageItemVo
     */
    invitedRegisterCount?: number;
    /**
     * 累计分成（所选年份内已结算的佣金总额）
     * @type {number}
     * @memberof CommissionPartnerPageItemVo
     */
    commissionAmount?: number;
}

/**
 * Check if a given object implements the CommissionPartnerPageItemVo interface.
 */
export function instanceOfCommissionPartnerPageItemVo(value: object): value is CommissionPartnerPageItemVo {
    return true;
}

export function CommissionPartnerPageItemVoFromJSON(json: any): CommissionPartnerPageItemVo {
    return CommissionPartnerPageItemVoFromJSONTyped(json, false);
}

export function CommissionPartnerPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionPartnerPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'account': json['account'] == null ? undefined : json['account'],
        'recommendCodes': json['recommendCodes'] == null ? undefined : ((json['recommendCodes'] as Array<any>).map(CommissionRecommendCodeVoFromJSON)),
        'invitedRegisterCount': json['invitedRegisterCount'] == null ? undefined : json['invitedRegisterCount'],
        'commissionAmount': json['commissionAmount'] == null ? undefined : json['commissionAmount'],
    };
}

export function CommissionPartnerPageItemVoToJSON(json: any): CommissionPartnerPageItemVo {
    return CommissionPartnerPageItemVoToJSONTyped(json, false);
}

export function CommissionPartnerPageItemVoToJSONTyped(value?: CommissionPartnerPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userCode': value['userCode'],
        'userName': value['userName'],
        'account': value['account'],
        'recommendCodes': value['recommendCodes'] == null ? undefined : ((value['recommendCodes'] as Array<any>).map(CommissionRecommendCodeVoToJSON)),
        'invitedRegisterCount': value['invitedRegisterCount'],
        'commissionAmount': value['commissionAmount'],
    };
}

